import "../src/global/global-pc.ts"

import "@modules/vue-modals/ad-free"
import "@modules/solads/solads"
import "../src/traffic-stars/traffic-stars-styles.css"
import "@modules/bookmarks/bookmarks-page-pc"
import { setAZMFilterPath } from "@modules/global/filter-path/filter-path-handler.ts"

setAZMFilterPath()
